import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { fetchUserApi, verifyOtpApi, logoutApi } from "../utils/api";
import FullScreenLoader from "../components/FullScreenLoader";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // console.log("userdata",localStorage.getItem("user"));
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // console.log("useAuth1" , user) ;
  
  const [token, setToken] = useState(localStorage.getItem("accessToken") || null);
  const [loading, setLoading] = useState(false); // Loader state
  const navigate = useNavigate();

  // ✅ Save token and user info
  const saveTokens = (accessToken, userData) => {
    // userData.user_role = userData.user_role.trim().toLowerCase(); 
    // userData.user_type = userData.user_type.trim().toLowerCase(); 
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("user", JSON.stringify(userData)); // Store as JSON
    setToken(accessToken);
    setUser(userData);
    
    // Auto-accept cookies when user logs in (hide cookie banner)
    const currentTime = new Date().getTime();
    localStorage.setItem('cookieAccepted', 'true');
    localStorage.setItem('cookieAcceptedTimestamp', currentTime.toString());
    
    // Trigger custom event to update cookie consent immediately
    window.dispatchEvent(new Event('cookieConsentChanged'));
  };

  // ✅ Verify OTP and store user data
  const verifyOtp = async (email, otp) => {
    try {
      setLoading(true);
      const { data } = await verifyOtpApi(email, otp);
      saveTokens(data.data.token, data.data.user);
      sessionStorage.clear();
      navigate("/dashboard");
    } catch (error) {
      console.error("OTP verification failed:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // ✅ Logout and clear local storage
  const logout = useCallback(() => {
    logoutApi();
    setToken(null);
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    navigate("/signin");
  }, [navigate]);

  // ✅ Fetch user details
  const fetchUser = useCallback(async () => {
    if (!token) {
      setUser(null);
      return;
    }

    setLoading(true);
    try {
      const { data } = await fetchUserApi();
      setUser(data.data);
    } catch (error) {
      console.error("Failed to fetch user:", error);
      setUser(null);
      setToken(null);
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
    } finally {
      setLoading(false);
    }
  }, [token]);

  // ✅ Run fetchUser on mount
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <AuthContext.Provider value={{ user, verifyOtp, logout, loading }}>
      <FullScreenLoader loading={loading} />
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
